/**
 * 영업건 진행단계 꼬리표 색 — 한 곳 (v2.309.0 · 개발요청 #22).
 *
 * 영업진행 목록·상세·판보 창이 같은 표를 각자 들고 있었고, 「영업건 검색」 칸(출고 등록 · 납품확인증 스캔본 ·
 * 나라장터 관급내역서·정산서 · 수출입 · 문서 영업 문서 탭)과 매입 창의 영업건 검색은 단계를 모두 회색으로 그렸다
 * (#22 「판보·발주가 헷갈린다」). 영업 문서 탭 목록·출고검수 「영업건 연결」 창은 자기 색 표를 따로 들고 있어
 * 같은 화면에서 색 뜻이 엇갈렸다. 이제 모두 이 표 하나를 쓴다 — 색 자체는 index.css 의 .stage-* .
 *
 * ⚠영업진행 목록의 빨간 「발주⚠」(구두 발주 = 발주 + 계약일 없음)는 목록에만 둔다 — 검색 칸의
 *   「선택」 줄은 계약일을 모르는 채로 그려지는 창이 있어(출고 수정 창 등) 같은 건이 줄마다 다르게 보인다.
 */

import type { SalesStatus } from './types';

export const STAGE_BADGE_CLASS: Record<SalesStatus, string> = {
  일반: 'stage-badge stage-propose',
  유력: 'stage-badge stage-likely',
  발주: 'stage-badge stage-order',
  납품: 'stage-badge stage-deliv',
  발행: 'stage-badge stage-issue',
  판보: 'stage-badge stage-report',
};

/** 단계 글자 → 꼬리표 class. 모르는 글자(빈 값 포함)는 null — 그리는 쪽이 꼬리표를 안 그린다. */
export function stageBadgeClass(status: string | null | undefined): string | null {
  return status && status in STAGE_BADGE_CLASS ? STAGE_BADGE_CLASS[status as SalesStatus] : null;
}

/** 단계가 아닌 안내 글자(수출입 라인 수정 창의 「현재 연결」 · 옛 「견적」)의 꼬리표 — 예전 회색 그대로 */
export const PLAIN_TAG_CLASS = 'inline-block px-1.5 py-0.5 rounded text-[11px] bg-slate-100 text-slate-600';

/** 꼬리표 class — 단계면 그 색, 그 밖의 글자면 회색, 빈 값이면 null(안 그림) */
export function statusTagClass(status: string | null | undefined): string | null {
  return stageBadgeClass(status) ?? (status ? PLAIN_TAG_CLASS : null);
}
